import { GeneratedContentTypeEnum } from 'gql/graphql';
import {
  AudioContent,
  ContentFormat,
  InteractiveContent,
  Presentations,
  WrittenContent
} from 'types/GeneratedContent';

export const contentFormatFactory = (contentType: GeneratedContentTypeEnum): ContentFormat[] => {
  const formats = [];

  switch (contentType) {
    case GeneratedContentTypeEnum.WrittenContent:
      for (const [_, val] of Object.entries(WrittenContent)) {
        formats.push(val);
      }
      return formats;
    case GeneratedContentTypeEnum.AudioContent:
      for (const [_, val] of Object.entries(AudioContent)) {
        formats.push(val);
      }
      return formats;
    case GeneratedContentTypeEnum.InteractiveContent:
      for (const [_, val] of Object.entries(InteractiveContent)) {
        formats.push(val);
      }
      return formats;
    case GeneratedContentTypeEnum.Presentations:
      for (const [_, val] of Object.entries(Presentations)) {
        formats.push(val);
      }
      return formats;
    default:
      return [];
  }
};
